export class UpdateAnnotationsDto {
    constructor(public Id: number, public Annotations: string, public TempName: string, public TempOriginalName: string) {
    }
}